import { AuthService } from '../user/auth.service';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { RegistryFirebaseService } from '../registry/registry-firebase.service';
import { Registry } from '../registry/registry';

@Injectable()
export class MerchantResolve implements Resolve<any> {
  constructor(
    private _registryFirebaseService: RegistryFirebaseService,
    private _authService: AuthService,
    private router: Router
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Registry> {
    return this._registryFirebaseService.regforUser().take(1);
  }
} 


// WEBPACK FOOTER //
// ./src/app/merchant/merchant.resolve.ts